import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d03a25a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "相关白皮书", -1));
const _hoisted_2 = {
  class: "paper-list"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "白皮书", -1));
const _hoisted_5 = {
  class: "btn"
};
const _hoisted_6 = {
  class: "right"
};
import ButtomCom from "@/components/buttomCom.vue";
import { ref } from "vue";
export default {
  __name: 'paperCom',
  props: {
    paperList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const jumpPage = (url, fileName, fileUrl) => {
      console.log(fileName);
      // 获取当前页面地址
      window.sessionStorage.setItem("fileName", fileName);
      window.sessionStorage.setItem("fileUrl", fileUrl);
      window.open(url);
    };
    let pageActive = ref(false);
    __expose({
      pageActive
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_unref(pageActive) ? 'white-paper-box active' : 'white-paper-box')
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.paperList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "paper-info",
          key: index
        }, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("p", null, _toDisplayString(item.whitePaperName), 1), _createElementVNode("div", _hoisted_5, [_createVNode(ButtomCom, {
          btnName: "立即下载",
          isArrow: true,
          style: {
            "font-size": "14px"
          },
          onClick: $event => jumpPage('/pdfDownload.html', item.whitePaperFileName, item.whitePaperFileUrl)
        }, null, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(item.whitePaperFileName), 1)])]);
      }), 128))])], 2);
    };
  }
};